var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-full-page" }, [
    _c(
      "div",
      { staticClass: "layout-full-page__header" },
      [
        _c("CompassLogo", { attrs: { type: "logo", width: 118 } }),
        _vm._v(" "),
        _c("CompassBackForwardButton", {
          attrs: {
            label: _vm.$t.__("common.actions.back"),
            link: _vm.backLink,
            type: "secondary",
            back: true
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "layout-full-page__content" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }